import { useEffect } from "react";
import { setAssessment } from "../store/slices/assessment";
import { setCurrentSlide, setPeekSlide } from "../store/slices/slides";
import { useDispatch } from "react-redux";

function usePersistAssessment() {
  const dispatch = useDispatch();
  useEffect(() => {
    let persisted_data = sessionStorage.getItem("persist_data");
    if (!persisted_data) {
      return;
    }

    persisted_data = JSON.parse(persisted_data);
    dispatch(setAssessment(persisted_data.assessment));
    dispatch(setCurrentSlide(persisted_data.currentSlide));
    dispatch(setPeekSlide(persisted_data.peekSlide));
    sessionStorage.removeItem("persist_data");
  }, []);

  return null;
}

export default usePersistAssessment;
